import React, { useRef, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line

const Container = tw.div`relative -mx-8 -mt-8`;
const Content = tw.div`mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
    ${tw`p-10 sm:p-12 md:p-16 bg-primary-500 text-gray-100 relative`}
    form {
        ${tw`mt-4`}
    }
    h2 {
        ${tw`text-3xl sm:text-4xl font-bold`}
    }
    input,
    textarea {
        ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 hocus:border-orange-800 focus:outline-none transition duration-200`}
        ::placeholder {
            ${tw`text-gray-300`}
        }
    }
`;

const ContactInfo = tw.div`my-8 text-sm sm:text-base text-gray-100`;
const InfoItem = tw.p`mb-1 flex items-center gap-2`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;

const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-primary-500 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const FeedbackMessage = styled.p(({ success }) => [
    tw`mt-4 text-sm text-center font-semibold`,
    success ? tw`text-green-300` : tw`text-red-300`
]);

export default () => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const formRef = useRef(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const formData = new FormData(event.target);

        fetch(event.target.action, {
            method: "POST",
            body: formData
        })
            .then((res) => {
                setLoading(false);
                setSuccess(true);
                formRef.current.reset();
                setTimeout(() => setSuccess(false), 3000);
            })
            .catch((err) => {
                setLoading(false);
                setError(true);
                setTimeout(() => setError(false), 3000);
            });
    };

    return (
        <Container id="contacto">
            <Content>
                <FormContainer>
                    <div tw="mx-auto max-w-4xl">
                        <h2>¿Querés hacernos una consulta, conocernos más o simplemente saludarnos?</h2>
                        <form
                            action="https://formsubmit.co/panificadosmylen@gmail.com"
                            method="POST"
                            ref={formRef}
                            onSubmit={handleSubmit}
                        >
                            <input type="hidden" name="_captcha" value="false" />
                            <input type="hidden" name="_subject" value="Formulario Web" />
                            <TwoColumn>
                                <Column>
                                    <InputContainer>
                                        <Label htmlFor="name-input">Nombre</Label>
                                        <Input
                                            id="name-input"
                                            type="text"
                                            name="nombre"
                                            placeholder="Nombre y Apellido"
                                            required
                                        />
                                    </InputContainer>
                                    <InputContainer>
                                        <Label htmlFor="email-input">Email</Label>
                                        <Input
                                            id="email-input"
                                            type="email"
                                            name="email"
                                            placeholder="Email"
                                            required
                                        />
                                    </InputContainer>
                                </Column>
                                <Column>
                                    <InputContainer tw="flex-1">
                                        <Label htmlFor="message-input">Tu Mensaje</Label>
                                        <TextArea
                                            id="message-input"
                                            name="mensaje"
                                            placeholder="Detalles sobre tu consulta"
                                            required
                                        />
                                    </InputContainer>
                                </Column>
                            </TwoColumn>

                            <SubmitButton type="submit" disabled={loading || success || error}>
                                {loading ? "Enviando..." : success ? "Enviado!" : "Enviar"}
                            </SubmitButton>

                            {(success || error) && (
                                <FeedbackMessage success={success}>
                                    {success
                                        ? "Gracias por tu mensaje. Te responderemos pronto."
                                        : "Ocurrió un error. Intentá de nuevo."}
                                </FeedbackMessage>
                            )}
                        </form>

                        <ContactInfo>
                            <InfoItem>📩 hola@panificadosmylen.com.ar</InfoItem>
                            <InfoItem>📱 WhatsApp: 341 309-6398</InfoItem>
                            <InfoItem>📍 Rosario, Santa Fe, Argentina</InfoItem>
                        </ContactInfo>
                    </div>
                </FormContainer>
            </Content>
        </Container>
    );
};
